<template>
    <div class="travelDetail">
        <home-nav-trip></home-nav-trip>
        <div class="charter-nav">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/travel' }">旅游出行</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/tourism' }">境外旅游</el-breadcrumb-item>
                <el-breadcrumb-item>
                    <!--{{ teamName }}-->
                    确认订单
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="sureOrder">
            <div class="sureOrderLeft">
                <div class="sureOrderLeftTop">
                    <div class="sureOrderLeftTopTit">
                        <span></span>
                        <p>
                            {{ t_title }}
                        </p>
                    </div>

                    <div class="sureOrderLeftTopDetail">

                        <div class="reservationTitSingle">
                            <div class="titleSingle">
                                出发城市:
                            </div>
                            <div class="mdCity">
                                {{ t_city }}
                            </div>
                        </div>

                        <div class="reservationTitSingle">
                            <div class="titleSingle" style="line-height: 40px;">
                                行程日期:
                            </div>
                            <div class="labelList">
                                <el-date-picker
                                        v-model="timeData"
                                        type="daterange"
                                        range-separator="至"
                                        :start-placeholder="beginDate"
                                        :end-placeholder="endDate"
                                        value-format="yyyy-MM-dd"
                                        :picker-options="pickerOptions0"
                                        @change="change">
                                </el-date-picker>
                            </div>
                        </div>

                        <div class="reservationTitSingle">
                            <div class="titleSingle">
                                出游人数:
                            </div>

                            <div class="travelNumber">
                                <div class="travelNumberBox">
                                    <div class="travelNumberBoxRight">
                                        <span @click="crreduce()">-</span>
                                        <p>{{ crNumber }}</p>
                                        <span @click="cradd()">+</span>
                                        <i>成人</i>
                                    </div>

                                    <div class="travelNumberBoxRight">
                                        <span @click="etreduce()">-</span>
                                        <p>{{ etNumber }}</p>
                                        <span @click="etadd()">+</span>
                                        <i>儿童</i>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="allContact">
                        <div class="allContactTit">
                            总联<br>
                            系人
                        </div>
                        <div class="contactDetail">
                            <div class="contactDetailRow">
                                <span>
                                    *
                                </span>
                                <p>
                                    中文姓名：
                                </p>
                                <input type="text" v-model="contact_name" placeholder="请输入总联系人的中文姓名">
                            </div>

                            <div class="contactDetailRow">
                                <span>
                                    *
                                </span>
                                <p>
                                    联系号码：
                                </p>
                                <input type="text" v-model="contact_tel" maxlength="11" placeholder="请输入您的联系方式">
                                <div class="contactDetailTip">
                                    用于接收确认短信
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tripPeople">
                        <div class="allContactTrip" v-for="(item, index) in List" :key="index">
                            <div class="allContactTitTrip">
                                <span class="title">游客{{ index+2 }}</span>
                                <span :class="item.isChengren ? 'titleTwo' : 'titleEt'">
                                    {{ item.isChengren ? '成人' : '儿童' }}
                                </span>
                            </div>
                            <div class="contactDetailTrip">
                                <div class="contactDetailRowTrip">
                                    <span>
                                        *
                                    </span>
                                    <p>
                                        中文姓名：
                                    </p>
                                    <input type="text" v-model="item.chaName" placeholder="请输入总联系人的中文姓名">
                                </div>

                                <div class="contactDetailRowTrip">
                                    <span>
                                        *
                                    </span>
                                    <p>
                                        联系号码：
                                    </p>
                                    <input type="text" v-model="item.telephone" maxlength="11" placeholder="请输入您的联系方式">
                                </div>

                                <div class="contactDetailRowTrip">
                                    <span>
                                        *
                                    </span>
                                    <p>
                                        证件类型：
                                    </p>
                                    <div class="cardBox">
                                        <div class="cardBoxTit">
                                            身份证
                                        </div>
                                        <input type="text" v-model="item.sfCard" placeholder="请输入身份证号码">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sureOrderRight">
                <div class="sureOrderRightTop">
                    <span></span>
                    <p>结算信息</p>
                    <span></span>
                </div>

                <div class="sureOrderRightDetail">
                    <div class="moneyAll">
                        <span class="moneyAllTitle">套餐明细</span>
                        <span class="moneyAllNumber">¥{{ payMoney }}</span>
                    </div>
                    <div class="moneyCr">
                        <span class="moneyCrTitle">成人</span>
                        <span class="moneyCrNumber">¥{{ crPrice }} x {{ this.crNumber }}</span>
                    </div>
                    <div class="moneyCr">
                        <span class="moneyCrTitle">儿童</span>
                        <span class="moneyCrNumber">¥{{ etPrice }} x {{ this.etNumber }}</span>
                    </div>
                </div>

                <div class="sureOrderRightAll">
                <span>
                  订单合计：
                </span>
                    <p>
                        ¥{{ payMoney }}
                    </p>
                </div>
            </div>
        </div>

        <div class="orderSubmit">
            <div class="orderSubmitBox">
                <div class="orderSubmitBoxLeft">
                    <el-checkbox v-model="checked">

                    </el-checkbox>
                    <span class="orderSubmitTit">我已同意并阅读</span>
                    <span class="orderSubmitColor"> 《预定须知》 </span>
                    <span class="orderSubmitColor">、</span>
                    <span class="orderSubmitColor"> 《旅游合同》 </span>
                </div>
                <div class="orderSubmitBoxBtn" @click="toPlace()">
                    提交订单
                </div>
            </div>
        </div>
        <!--底部-->
        <home-footer></home-footer>
    </div>
</template>

<script>
    import {mapMutations, mapGetters} from 'vuex';
    import homeNavTrip from '@/components/homeNavTrip';
    import homeFooter from '@/components/homeFooter';

    export default {
        name: "ConfirmOrder",
        components: {
            homeNavTrip,
            homeFooter
        },
        data() {
            return {
                beginDate: '', //起始时间
                endDate: '', //终止时间
                timeData: [],
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                crNumber: 0,
                etNumber: 0,
                List: [
                    /*{
                        chaName: "",
                        telephone: "",
                        sfCard: "",
                        isChengren: ''
                        isCrId: ''
                    }*/
                ],

                personObj: {
                    chaName: "",
                    telephone: "",
                    sfCard: "",
                    isChengren: true,
                    isCrId: ''
                },
                personObjOther: {
                    chaName: "",
                    telephone: "",
                    sfCard: "",
                    isChengren: false,
                    isCrId: ''
                },
                crPrice: 0,
                etPrice: 0,
                checked: false,
                t_id: '',
                contact_name: '',
                contact_tel: '',
                t_title: '',
                t_city: '',
            }
        },
        computed: {
            ...mapGetters(['getCrNumber', 'getEtNumber']),
            payMoney() {
                return this.crPrice * this.crNumber + this.etPrice * this.etNumber;
            }
        },
        watch: {
            /*getCrNumber(newVal,oldVal){
                console.log(newVal,oldVal);
                this.addForm(newVal, 'cr');
            },
            getEtNumber(newVal,oldVal){
                console.log(newVal,oldVal);
                this.addForm(newVal, 'et');
            }*/
        },
        created() {
            this.t_id = this.$route.query.id;
            var self = this;
            this.List = [];
            self.crNumber = self.getCrNumber;
            self.etNumber = self.getEtNumber;
            if (self.crNumber > 1) {
                this.addFormCsh(self.crNumber - 1, 'cr');
            }
            if (self.etNumber > 0) {
                this.addFormCsh(self.etNumber, 'et');
            }
        },
        mounted() {
            this.travelOrderPage();
            this.getPassYearFormatDate();
        },
        methods: {
            ...mapMutations(['saveCrNumber', 'saveEtNumber']),

            /* 获取过去时间，并传值给现在时间 */
            getPassYearFormatDate() {
                var nowDate = new Date();
                var date = new Date(nowDate);
                date.setDate(date.getDate() - 0); // 365
                var seperator1 = '-';
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = '0' + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = '0' + strDate;
                }
                var formatDate = year + seperator1 + month + seperator1 + strDate;
                this.getNowFormatDate(formatDate);
            },
            /* 获取现在时间，并接受过去时间的值 */
            getNowFormatDate(formatDate) {
                var date = new Date();
                var seperator1 = '-';
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = '0' + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = '0' + strDate;
                }
                var nowData = year + seperator1 + month + seperator1 + strDate;
                this.timeData = [formatDate, nowData];  // 默认赋值一年时间
            },

            crreduce() {
                if (this.crNumber <= 1) {
                    return;
                } else {
                    this.crNumber--;
                    this.reduceForm(1, 'cr');
                    this.saveCrNumber({'crNumber': this.crNumber});
                }
                // this.calculatePrice();
            },

            cradd() {
                this.crNumber++;
                this.saveCrNumber({'crNumber': this.crNumber});
                this.addForm(1, 'cr');
                // this.calculatePrice();
            },

            etreduce() {
                if (this.etNumber <= 0) {
                    return;
                } else {
                    this.etNumber--;
                    this.reduceForm(1, 'et');
                    this.saveEtNumber({'etNumber': this.etNumber});
                }
                // this.calculatePrice();
            },

            etadd() {
                this.etNumber++;
                this.saveEtNumber({'etNumber': this.etNumber});
                this.addForm(1, 'et');
                // this.calculatePrice();
            },

            // 添加表单
            addForm(a, type) {
                let arr;
                if (type == 'cr') {
                    arr = this.cloneObj(this.personObj);
                    arr.isCrId = 'crid' + this.crNumber;
                } else {
                    arr = this.cloneObj(this.personObjOther);
                    arr.isCrId = 'etid' + this.etNumber;
                }
                // console.log(a,"arr", arr);
                this.List.push(arr);
                a--;
                if (a > 0) {
                    this.addForm(a - 1);
                }
            },

            reduceForm(a, type) {
                if (type == 'cr') {
                    var index = this.List.findIndex(item => {
                        // console.log(item.isCrId, this.crNumber)
                        if (item.isCrId == ('crid' + (this.crNumber + 1))) {
                            return true
                        }
                    })
                    // console.log(index);
                    this.List.splice(index, 1);
                } else if (type == 'et') {
                    var index = this.List.findIndex(item => {
                        // console.log(item.isCrId, this.crNumber)
                        if (item.isCrId == ('etid' + (this.etNumber + 1))) {
                            return true
                        }
                    })
                    // console.log(index);
                    this.List.splice(index, 1);
                }
            },

            // 初始化添加表单
            addFormCsh(a, type) {
                // console.log(a, type);
                let arr;
                if (type == 'cr') {
                    arr = this.cloneObj(this.personObj);
                    arr.isCrId = 'crid' + (a + 1);
                } else {
                    arr = this.cloneObj(this.personObjOther);
                    arr.isCrId = 'etid' + a;
                }
                // console.log(a,"arr", arr);
                this.List.push(arr);
                a--;
                if (a > 0) {
                    if (type == 'cr') {
                        this.addFormCsh(a, 'cr');
                    } else {
                        this.addFormCsh(a, 'et');
                    }
                }
            },

            cloneObj(obj) {
                let ret;
                if (Array.isArray(obj)) {
                    //创建一个空数组
                    ret = [];
                    for (let i = 0; i < obj.length; i++) {
                        ret[i] = this.cloneObj(obj[i]);
                    }
                    return ret;
                } else if (Object.prototype.toString.call(obj) === "[object Object]") {
                    ret = {};
                    for (let i in obj) {
                        ret[i] = this.cloneObj(obj[i]);
                    }
                    return ret;
                } else {
                    return obj;
                }
            },

            /*提交*/
            toPlace() {
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                var parmas = {};
                parmas.t_id = this.t_id;
                parmas.adult_num = this.crNumber;
                parmas.child_num = this.etNumber;
                parmas.contact_name = this.contact_name;
                parmas.contact_tel = this.contact_tel;
                parmas.start_time = this.timeData[0];
                parmas.end_time = this.timeData[1];

                if (parmas.contact_name == '') {
                    this.$message('总联系人姓名不能为空');
                    return;
                }

                if (parmas.contact_tel == '') {
                    this.$message('总联系人号码不能为空');
                    return;
                }

                if (!myreg.test(parmas.contact_tel)) {
                    this.$message('请输入正确的手机号码！');
                    return;
                }


                if (parmas.start_time == '' || parmas.start_time == undefined || parmas.start_time == null) {
                    this.$message('请选择行程日期');
                    return;
                }

                var peopleArray = new Array();
                var item = this.List;
                for (var i = 0; i < item.length; i++) {
                    peopleArray[i] = {};
                    if (item[i].chaName == '') {
                        this.$message('请分别输入游客姓名！');
                        return;
                    }
                    /*if (!myreg.test(item[i].telephone)) {
                        this.$message('请输入正确的手机号码！');
                        return;
                    }*/
                    if (item[i].isChengren && item[i].sfCard == '') {
                        this.$message('请分别输入成人游客身份证号！');
                        return;
                    }
                    peopleArray[i].name = item[i].chaName;
                    peopleArray[i].mobile = item[i].telephone;
                    peopleArray[i].idnumber = item[i].sfCard;
                    peopleArray[i].status = item[i].isChengren  ? 1 : 2;
                };
                parmas.peopleArr = peopleArray;
                // console.log(peopleArray);

                if (this.checked == false) {
                    this.$message('请同意并阅读《预定须知》《旅游合同》');
                    return;
                }

                const loading = this.$loading({
                    lock: true,
                    text: '数据加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                this.$axios.post('/travelOrderSub', {
                    parmas,
                }).then((res) => {
                    loading.close();
                    res = res.data;
                    console.log(res);
                    if (res.status == 200) {
                        this.$router.push({name: "PlaceOrder", params: {o_id: res.data}});
                    } else {
                        loading.close();
                        this.$message(res.msg);
                    }
                }).catch((error) => {
                    loading.close();
                });

            },

            /*获取信息*/
            travelOrderPage() {
                var that = this;
                const loading = this.$loading({
                    lock: true,
                    text: '数据加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                that.$axios.post('/travelOrderPage', {
                    t_id: that.t_id,
                }).then((res) => {
                    loading.close();
                    res = res.data;
                    // console.log(res);
                    if (res.status == 200) {
                        that.t_title = res.data.title;
                        that.t_city = res.data.city_name;
                        that.crPrice = res.data.adult_price;
                        that.etPrice = res.data.child_price ? res.data.child_price : 0;
                    } else {
                        loading.close();
                        this.$message(res.message);
                    }
                }).catch((error) => {
                    loading.close();
                });
            },

            /*计算价格*/
            calculatePrice() {
                this.payMoney = this.crPrice * this.crNumber + this.etPrice * this.etNumber;
            },

            change() {
                // 确定时间范围之后触发的函数
            }
        }
    }
</script>

<style scoped>
    @import './confirmOrder.css';
</style>



// WEBPACK FOOTER //
// src/pages/confirmOrder/confirmOrder.vue